"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toArticleListSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toArticleListSlice = function (data, logger) {
    var _a, _b;
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.ArticleList)), { title: fields_1.toText((_a = data.primary) === null || _a === void 0 ? void 0 : _a.section_title), maxArticles: fields_1.toNumber((_b = data.primary) === null || _b === void 0 ? void 0 : _b.nbTiles, {
            defaultValue: 20
        }), cta: field_groups_1.toCta(utils_1.unprefix('section', data.primary), logger) }));
};
exports.toArticleListSlice = toArticleListSlice;
//# sourceMappingURL=article-list-slice.js.map